export const NEWS_ROUTE = 'aktualnosci';
